import { FlatTreeControl } from '@angular/cdk/tree';
import { CollectionViewer, DataSource, SelectionChange } from '@angular/cdk/collections';
import { Observable, BehaviorSubject } from 'rxjs';

export class McRAITreeDataSource<T> extends DataSource<T> {
  private _data: BehaviorSubject<T[]>;
  set data(value: T[]) {
    this._data.next(value);
  }
  get data(): T[] {
    return this._data.value;
  }

  constructor(
    private _treeControl: FlatTreeControl<T>,
    private _toggleNode: any = null,
    private _initialData: T[] = []
  ) {
    super();
    this._data = new BehaviorSubject<T[]>(_initialData);

    this._data.subscribe(value => this._treeControl.dataNodes = value);
  }

  private _handleToggles(changes: SelectionChange<T>): void {
    if (this._toggleNode) {
      if (changes.added.length > 0) {
        changes.added.forEach(node => {
          this._toggleNode(this._data, node, true);
        });
      }

      if (changes.removed.length > 0) {
        changes.removed.forEach(node => {
          this._toggleNode(this._data, node, false);
        });
      }
    }

    this._treeControl.dataNodes = this.data;
  }

  public connect(collectionViewer: CollectionViewer): Observable<T[]> {
    this._treeControl
      .expansionModel
      .onChange
      .subscribe((changes: SelectionChange<T>) => this._handleToggles(changes));

    return this._data;
  }

  public disconnect() { }
}
